import ScoreTiersSelector from '@v4/utils/selectors/ScoreTiersSelector'
import { useCallback } from 'react'
import useStyles from './ScoreTierDropdown.styled'

export const useScoreTierDropdown = props => {
	const { onChange, value } = props
	const scoreTiers = ScoreTiersSelector.useData()
	const classes = useStyles(props)

	const handleChange = useCallback(
		(event, { props: { value: tierId } }) => {
			onChange?.(tierId)
		},
		[onChange],
	)

	return [{ classes, scoreTiers, value: value ?? '' }, { handleChange }]
}
